import script from "./SchoolYears.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolYears.vue?vue&type=script&setup=true&lang=js"

import "./SchoolYears.vue?vue&type=style&index=0&id=73532f61&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73532f61"]])

export default __exports__